import {
  Operation,
  Exchange,
  ExchangeInput,
  OperationResult
} from "@urql/core";
import { pipe, tap } from "wonka";
import { datadogLogs } from "@datadog/browser-logs";
import { getId } from "store";

type OperationState = {
  startDate: Date;
  operation: string;
};

/**
 * A proof on concept exchange, will track when operations start/stop and log slow ones as warning to data dog.
 * @param forward
 */
export const loggerExchange: Exchange = ({ forward }: ExchangeInput) => {
  const operations = new Map<number, OperationState>();
  const logStart = ({ key, query, kind }: Operation) => {
    if (kind === "teardown" || kind === "subscription") {
      return;
    }
    operations.set(key, {
      startDate: new Date(),
      operation: getId(query)
    });
  };
  const logEnd = ({ operation: { key, kind } }: OperationResult) => {
    if (kind === "teardown" || kind === "subscription") {
      return;
    }
    const start = operations.get(key);
    if (!start) {
      return;
    }
    const { startDate, operation } = start;
    const currentTime = new Date().getTime();
    operations.delete(key);
    const duration = currentTime - startDate.getTime();
    datadogLogs.logger.debug(`Completed ${kind}`, {
      operation,
      duration
    });
    if (duration > 6000) {
      datadogLogs.logger.warn(`Slow ${kind}`, {
        operation,
        duration
      });
    }
  };
  return ops$ => pipe(ops$, tap(logStart), forward, tap(logEnd));
};
